export default __webpack_public_path__ + "static/media/singleDoor.17d8f11b.png";